import * as React from "react";

const SvgGlobe = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 700 700"
    style={{
      enableBackground: "new 0 0 700 700",
    }}
    xmlSpace="preserve"
    {...props}
  >
    <symbol id="globe_svg__i" viewBox="-11.4 -11.2 22.8 22.3">
      <path d="M11.4-.1v1.9H-4.5c.2 1.6.7 2.8 1.7 3.6 1 .8 2.4 1.2 4.1 1.2 1.4 0 2.9-.2 4.4-.6 1.5-.4 3-1.1 4.6-1.9v5.2c-1.6.6-3.2 1.1-4.8 1.4-1.5.3-3.1.5-4.7.5-3.8 0-6.8-1-9-2.9-2.1-2-3.2-4.7-3.2-8.2 0-3.5 1-6.2 3.1-8.2 2.1-2 5-3 8.7-3 3.3 0 6 1 8 3s3 4.7 3 8zm-7-2.2c0-1.3-.4-2.3-1.1-3.1-.8-.8-1.7-1.2-3-1.2s-2.3.3-3.2 1.1c-.8.7-1.3 1.8-1.5 3.2h8.8z" />
    </symbol>
    <symbol id="globe_svg__f" viewBox="-8.6 -13.7 17.2 27.3">
      <path d="M1.6-13.7v6h7v4.9h-7v9c0 1 .2 1.7.6 2 .4.3 1.2.5 2.3.5H8v4.9H2.2c-2.7 0-4.6-.6-5.7-1.7-1.1-1.1-1.7-3-1.7-5.7v-9h-3.4v-4.9h3.4v-6h6.8z" />
    </symbol>
    <symbol id="globe_svg__c" viewBox="-7.9 -10.9 15.8 21.8">
      <path d="M7.9-4.6c-.6-.3-1.2-.5-1.8-.6-.6-.1-1.2-.2-1.7-.2-1.8 0-3.1.6-4 1.7-1 1.1-1.5 2.7-1.5 4.8v9.8h-6.8v-21.3h6.8v3.5c.9-1.4 1.9-2.4 3-3 1.1-.6 2.5-1 4.1-1h.7c.3 0 .7.1 1.2.1v6.2z" />
    </symbol>
    <symbol id="globe_svg__l" viewBox="-11.7 -11.2 23.4 22.3">
      <path d="M0-6.3c-1.5 0-2.7.5-3.5 1.6C-4.2-3.6-4.6-2-4.6 0s.4 3.6 1.2 4.7c.8 1.1 1.9 1.6 3.4 1.6s2.6-.5 3.4-1.6C4.2 3.6 4.6 2 4.6 0s-.4-3.6-1.2-4.7C2.6-5.8 1.5-6.3 0-6.3zm0-4.9c3.7 0 6.5 1 8.6 3 2.1 2 3.1 4.7 3.1 8.2 0 3.5-1 6.2-3.1 8.2-2.1 2-4.9 3-8.6 3-3.7 0-6.6-1-8.6-3-2.1-2-3.1-4.7-3.1-8.2 0-3.5 1-6.2 3.1-8.2 2.1-2 5-3 8.6-3z" />
    </symbol>
    <path d="M350 73.9C197.6 73.9 73.9 197.6 73.9 350S197.6 626.1 350 626.1c152.5 0 276.1-123.7 276.1-276.1S502.4 73.9 350 73.9zm-7.8 506.3c-1.6.8-3.1 1.6-4.7 1.6-30.3 3.1-60.7-7.8-85.6-24.9-24.9-17.1-45.9-39.7-66.1-63-11.7-13.2-23.3-27.2-33.4-42-10.1-15.6-17.9-33.4-15.6-51.3 2.3-17.9 16.3-35 34.2-37.3 3.9-.8 7.8 0 10.9 1.6 8.6 5.4 8.6 20.2 18.7 22.6 7 1.6 16.3-3.9 20.2 2.3 1.6 1.6 1.6 3.9 1.6 6.2 1.6 8.6 6.2 16.3 13.2 21 4.7 3.1 10.1 4.7 14 8.6 5.4 6.2 5.4 14.8 10.9 21 6.2 8.6 18.7 10.1 24.9 17.9 6.2 8.6 4.7 20.2 9.3 29.6 3.1 7.8 9.3 13.2 15.6 18.7 15.6 15.6 27.2 35 32.7 56.8 1.6 4.4 2.3 8.3-.8 10.6zM492.3 525c-1.6 5.4-3.1 10.9-7.8 14-6.2 4.7-16.3 1.6-21-5.4s-5.4-15.6-5.4-23.3c.8-24.9 7-51.3-2.3-74.7-4.7-11.7-12.4-21.8-17.1-33.4-4.7-11.7-5.4-26.4 3.9-35 2.3-2.3 5.4-3.9 6.2-7 3.1-7-3.9-14-10.1-16.3-17.9-7-39.7-.8-54.4-15.6-4.7-4.7-7-10.1-8.6-16.3-1.6-7-7-13.2-14.8-14.8-10.1-2.3-19.4-10.9-24.9-20.2-7.8-14.8-11.7-31.9-22.6-43.6-3.1-3.9-7.8-7-10.1-11.7-3.1-5.4-2.3-12.4-3.1-18.7 0-8.6-8.6-15.6-17.1-14-7 .8-14.8 1.6-21.8 0-10.9-2.3-21.8-10.1-23.3-21.8-1.6-10.9 7-23.3 18.7-24.9 5.4-.8 10.9.8 16.3 1.6 24.9 2.3 49.8-12.4 73.1-3.9 5.4 2.3 10.9 5.4 16.3 7.8 20.2 7.8 42.8-3.1 63 .8 6.2 1.6 10.9 7 10.1 12.4-.8 9.3-11.7 10.9-17.1 17.1-6.2 7.8-1.6 20.2 7 25.7 8.6 5.4 18.7 5.4 28.8 5.4 3.1 0 7 0 9.3-2.3 7.8-6.2-2.3-20.2 3.9-28 3.9-4.7 10.1-3.9 15.6-2.3 23.3 7.8 36.6 38.9 23.3 59.1-6.2 9.3-15.6 15.6-24.9 21L431.7 287c-10.9 6.2-10.1 22.6 1.6 28 11.7 5.4 26.4 9.3 33.4 19.4 3.9 4.7 5.4 10.9 8.6 15.6 9.3 12.4 26.4 14 42 17.1 17.9 3.9 35 12.4 49 24.1 7 5.4 8.6 14.8 5.4 23.3-14.8 41.3-63.8 66.9-79.4 110.5z" />
    <defs>
      <path id="globe_svg__a" d="M86.9 715.6h700v700h-700z" />
    </defs>
    <clipPath id="globe_svg__b">
      <use
        xlinkHref="#globe_svg__a"
        style={{
          overflow: "visible",
        }}
      />
    </clipPath>
    <g
      style={{
        clipPath: "url(#globe_svg__b)",
      }}
    >
      <use
        xlinkHref="#globe_svg__c"
        width={15.8}
        height={21.8}
        x={-7.9}
        y={-10.9}
        transform="translate(98.082 704.664)"
        style={{
          overflow: "visible",
        }}
      />
    </g>
    <defs>
      <path id="globe_svg__d" d="M186.9 715.6h700v700h-700z" />
    </defs>
    <clipPath id="globe_svg__e">
      <use
        xlinkHref="#globe_svg__d"
        style={{
          overflow: "visible",
        }}
      />
    </clipPath>
    <g
      style={{
        clipPath: "url(#globe_svg__e)",
      }}
    >
      <use
        xlinkHref="#globe_svg__f"
        width={17.2}
        height={27.3}
        x={-8.6}
        y={-13.7}
        transform="translate(195.985 701.899)"
        style={{
          overflow: "visible",
        }}
      />
    </g>
    <defs>
      <path id="globe_svg__g" d="M233.2 715.6h700v700h-700z" />
    </defs>
    <clipPath id="globe_svg__h">
      <use
        xlinkHref="#globe_svg__g"
        style={{
          overflow: "visible",
        }}
      />
    </clipPath>
    <g
      style={{
        clipPath: "url(#globe_svg__h)",
      }}
    >
      <use
        xlinkHref="#globe_svg__i"
        width={22.8}
        height={22.3}
        x={-11.4}
        y={-11.2}
        transform="translate(246.238 704.937)"
        style={{
          overflow: "visible",
        }}
      />
    </g>
    <defs>
      <path id="globe_svg__j" d="M305.6 715.6h700v700h-700z" />
    </defs>
    <clipPath id="globe_svg__k">
      <use
        xlinkHref="#globe_svg__j"
        style={{
          overflow: "visible",
        }}
      />
    </clipPath>
    <g
      style={{
        clipPath: "url(#globe_svg__k)",
      }}
    >
      <use
        xlinkHref="#globe_svg__l"
        width={23.4}
        height={22.3}
        x={-11.7}
        y={-11.2}
        transform="translate(318.973 704.937)"
        style={{
          overflow: "visible",
        }}
      />
    </g>
    <defs>
      <path id="globe_svg__m" d="M429.7 715.6h700v700h-700z" />
    </defs>
    <clipPath id="globe_svg__n">
      <use
        xlinkHref="#globe_svg__m"
        style={{
          overflow: "visible",
        }}
      />
    </clipPath>
    <g
      style={{
        clipPath: "url(#globe_svg__n)",
      }}
    >
      <use
        xlinkHref="#globe_svg__c"
        width={15.8}
        height={21.8}
        x={-7.9}
        y={-10.9}
        transform="translate(440.906 704.664)"
        style={{
          overflow: "visible",
        }}
      />
    </g>
    <defs>
      <path id="globe_svg__o" d="M448.9 715.6h700v700h-700z" />
    </defs>
    <clipPath id="globe_svg__p">
      <use
        xlinkHref="#globe_svg__o"
        style={{
          overflow: "visible",
        }}
      />
    </clipPath>
    <g
      style={{
        clipPath: "url(#globe_svg__p)",
      }}
    >
      <use
        xlinkHref="#globe_svg__l"
        width={23.4}
        height={22.3}
        x={-11.7}
        y={-11.2}
        transform="translate(462.278 704.937)"
        style={{
          overflow: "visible",
        }}
      />
    </g>
    <defs>
      <path id="globe_svg__q" d="M489 715.6h700v700H489z" />
    </defs>
    <clipPath id="globe_svg__r">
      <use
        xlinkHref="#globe_svg__q"
        style={{
          overflow: "visible",
        }}
      />
    </clipPath>
    <g
      style={{
        clipPath: "url(#globe_svg__r)",
      }}
    >
      <use
        xlinkHref="#globe_svg__i"
        width={22.8}
        height={22.3}
        x={-11.4}
        y={-11.2}
        transform="translate(502.055 704.937)"
        style={{
          overflow: "visible",
        }}
      />
    </g>
    <defs>
      <path id="globe_svg__s" d="M538.4 715.6h700v700h-700z" />
    </defs>
    <clipPath id="globe_svg__t">
      <use
        xlinkHref="#globe_svg__s"
        style={{
          overflow: "visible",
        }}
      />
    </clipPath>
    <g
      style={{
        clipPath: "url(#globe_svg__t)",
      }}
    >
      <use
        xlinkHref="#globe_svg__f"
        width={17.2}
        height={27.3}
        x={-8.6}
        y={-13.7}
        transform="translate(547.504 701.899)"
        style={{
          overflow: "visible",
        }}
      />
    </g>
  </svg>
);

export default SvgGlobe;
